<!--基于v-charts和echarts的柱状图-->
<template>
  <div class="chart">
    <ve-histogram
      height="100%"
      :data="chartData"
      :settings="chartSettings"
      :extend="chartExtends"
      :loading="loading"
      :data-empty="data.length? false: true"
    />
  </div>
</template>
<script>
export default {
  props: {
    columns: {
      type: Array,
      default: () => { return [] }
    },
    data: {
      type: Array,
      default: () => { return [] }
    },
    setting: {
      type: Object,
      default: () => { return {} }
    },
    extend: {
      type: Object,
      default: () => { return {} }
    },
    loading: Boolean,
    unit: {
      default: '',
      type: String
    },
    format: {
      type: Array,
      default () {
        return ['yyyy-MM-dd hh:mm']
      }
    }
  },
  data () {
    return {
      chartData: {
        columns: this.columns,
        rows: this.data
      }
    }
  },
  computed: {
    chartSettings () {
      return this.setting
    },
    chartExtends () {
      const _this = this
      /**
       * 此处配置参考echart的配置项
      */
      const extend = this.extend || {}
      const o = {
        grid: {
          left: 50,
          right: 50
        },
        xAxis: {
          axisLabel: {
            formatter: (value) => {
              return _this.$parseTime(value, this.format[0])
            }
          }
        },
      }
      Object.assign(o, extend)
      return o
    }
  },
  watch: {
    data: {
      handler: function (val) {
        this.chartData.rows = val
      },
      deep: true // 对象内部的属性监听，也叫深度监听
    },
    columns (val) {
      this.chartData.columns = val
    }
  }
}
</script>
<style lang="stylus" scoped>
.chart
  height 100%
  width 100%
/deep/.v-charts-data-empty
  background-color: #1C2550
  color #1cc197
  font-size 16px
</style>
